import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=0fcc81b6&scoped=true&"
import script from "./Base.vue?vue&type=script&lang=js&"
export * from "./Base.vue?vue&type=script&lang=js&"
import style0 from "./Base.vue?vue&type=style&index=0&id=0fcc81b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcc81b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fcc81b6')) {
      api.createRecord('0fcc81b6', component.options)
    } else {
      api.reload('0fcc81b6', component.options)
    }
    module.hot.accept("./Base.vue?vue&type=template&id=0fcc81b6&scoped=true&", function () {
      api.rerender('0fcc81b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Importacao/Base.vue"
export default component.exports